module.exports = __webpack_public_path__ + "a818e6131c83cd57774663fd64f2171f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile21.png
// module id = 1882
// module chunks = 0